// Module
var code = `<template class="connector-line">
  <require from="./connector-line.scss"></require>
  <svg if.bind="width" width.bind="width" height.bind="height+50">
    <path if.bind="leftHigher" d="M 0 0 C \${width/2} 0 \${width/2} \${height} \${width} \${height}"/>
    <path else d="M 0 \${height} C \${width/2} \${height} \${width/2} 0 \${width} 0"/>
  </svg>
</template>
`;
// Exports
export default code;